import api from "@/services/api";

const _http = {
    async getAll() {
        try {
            const response = await api.get("/division");
            return response;
        } catch (error) {
            console.error("Division Service Error:", error.response?.data || error.message);
            throw error;
        }
    },

};




export default {
    async getAll(query={}) {
        try {
            const res = await _http.getAll(query);
            return {
                data: res.data.data.map((division) => division),
            };
        } catch (error) {
            console.error(error);
            return {
                data: [],
            };
        }
    }
}
